export const ONLINE_PROCESSING_INFO = "ONLINE_PROCESSING_INFO";
export const ONLINE_CUSTOMER_DETAIL_TITLE = "ONLINE_CUSTOMER_DETAIL_TITLE";

export const ONLINE_INSTANT_DISCOUNT = "ONLINE_INSTANT_DISCOUNT";
